import { RouteConfig } from "vue-router"

/**
 * RouteConfigを定義します: [NegativeHistory]。
 */
export const NegativeHistoryRouteConfig: RouteConfig = {
  path: "/NegativeHistory",
  name: "NegativeHistory",
  component: () => import("%%/views/negativeHistory/NegativeHistory.vue"),
  meta: {
    reload: false,
    authRequired: true,
  },
}
